// Section Master API services for dynamic form

import {
    mtBuildRequestHeader,
    mtHandleErrorResponse,
    mtHandleRequestFailure,
    mtParseJsonResponse,
    mtUrlBuilder,
    type MTApiResponse,
} from '@/multi-territory/mt-services/mt-api-utils'
import type { MTFormFieldOption } from '@/multi-territory/mt-types/mt-section-form-config'

// --- Endpoints ---
const SECTION_BROADHEAD_API =
  'wht-data-management/api/v1/section-masters/fetch/unique/section-broadheads'

/**
 * Fetches unique section-broadhead mapping from BE.
 * Returns: { "393(3)-1 [old:194B]": ["Winnings from lottery..."], ... }
 */
export async function fetchSectionBroadheads(): Promise<
  MTApiResponse<Record<string, string[]>>
> {
  try {
    const url = mtUrlBuilder(SECTION_BROADHEAD_API)
    const options = mtBuildRequestHeader('GET')
    const response = await fetch(url, options)

    if (!response.ok) {
      return await mtHandleRequestFailure(response)
    }

    return await mtParseJsonResponse<Record<string, string[]>>(response)
  } catch (error) {
    return mtHandleErrorResponse(error)
  }
}

/**
 * Given the full broadhead map and a selected section code,
 * returns the filtered options for the broad head dropdown.
 * If only 1 option exists, it will be auto-selected by the form component.
 */
export function getBroadheadOptionsForSection(
  broadheadMap: Record<string, string[]>,
  sectionCode: string
): MTFormFieldOption[] {
  const values = broadheadMap[sectionCode]
  if (!values || values.length === 0) return []
  return values.map(v => ({ label: v, value: v }))
}
